
export default {
	orders: {},
	orderIds: [],
	currentOrder: null,
}